export default {
    cz: {
        title: 'Ke zvolenému produktu si zákazníci obvykle půjčují také:',
    },
    sk: {
        title: 'K zvolenému produktu si zákazníci obvykle požičiavajú tiež:',
    },
}
